import React, { useState } from 'react';
import styles from './LandingModal.module.scss';
import { Modal, Checkbox, Radio, RadioGroup, Group, TextInput, Text, Button, LoadingOverlay, Space, Grid } from '@mantine/core';
import { useForm } from '@mantine/form';

import useTranslation from '../../hooks/useTranslation';
import { useDispatch, useSelector } from 'react-redux';
import { appActions, selectDomainCountry, selectProductCode } from '../../redux/appSlice';
import { makeOrder } from '../../services/api';
import { store } from '../../redux/store';
import { indiaProducts } from '../../redux/staticData'

import ContactForm from '../contact-form/ContactForm';

// import { useDebouncedCallback } from "use-debounce";

const LS_EMAIL = "rememberEmail"

type Props = {
  executeRecaptcha: any,
  children?: React.ReactNode,
}

function LandingModal({ executeRecaptcha }: Props) {

  const dispatch = useDispatch()
  const t = useTranslation()
  const domainCountry = useSelector(selectDomainCountry)
  const productCode = useSelector(selectProductCode)

  const [loading, setLoading] = useState(false)
  const [selectedView, setSelectedView] = useState<string|null>(null)

  const indiaProduct = ( indiaProducts.indexOf(productCode) !== -1 )

  const form = useForm({
    initialValues: {
      email: localStorage.getItem(LS_EMAIL) || '', // TODO: get from local storage
      cad: false,
      bim: false,
      lod: '200', // or '200'
      remember: !!localStorage.getItem(LS_EMAIL),
    },
    validate: {
      email: (value) => (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) ? null : t('ui-form-invalid-email')),
    },
  });

  const submit = async (values: any) => {
    
    setLoading(true)

    console.log('form values:',{values})
    if (values.remember) {
      localStorage.setItem(LS_EMAIL, values.email)
    } else {
      localStorage.removeItem(LS_EMAIL)
    }

    const { recaptchaToken, recaptchaNumber } = await executeRecaptcha('download_kone_com')

    makeOrder(store, {...values, recaptchaToken, recaptchaNumber}).then(({ success }) => {
      if (success) {
        dispatch(appActions.setCurrentEmail(values.email))
        dispatch(appActions.setNotifyState("ready"))
      } else {
        // TODO: Add error field
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  const submitOnlyOrder = async () => {
    const values = JSON.parse(JSON.stringify(form.values))
    values.email = 'not-yet'
    const { recaptchaToken, recaptchaNumber } = await executeRecaptcha('download_kone_com')

    makeOrder(store, { ...values, recaptchaToken, recaptchaNumber }).then(({ success }) => {
      if (success) {
        setSelectedView('contactStep2')
      } else {
        // TODO: Add error field
      }
    }).catch((error) => {
      console.log(error)
    })

  }
/*   const debounced = useDebouncedCallback( (target:any, cTarget:any, key:string) => {
    target.currentTarget =  cTarget
    form.getInputProps(key as keyof typeof form.values).onChange(target)
  }, 300)

  const handleFormOnChange = (event:any, key:string) => {
    if (event.currentTarget === document.activeElement) 
    {
      debounced(event, event.currentTarget, key)
    } else {
      form.getInputProps(key as keyof typeof form.values).onChange(event)
    } 
  }
 */
  return (
    <Modal
      classNames={{ modal: styles.modal }}
      opened={true}
      withCloseButton={false}
      onClose={() => {/** outside click */ }}
      centered
      overflow="inside"
      size={640}
    >
      <LoadingOverlay visible={loading} />

      {selectedView === null &&
        <>
          <div className={styles.title}>{t('ui-landing-welcome')}</div>
        <div className={styles.desc}>{t('ui-landing-your-files-are-soon-ready') }</div>
        <div className={styles.desc}>{t('ui-landing-do-you-want-to-contact-kone')}</div>
          <Grid gutter={24} style={{width:'100%', padding:'0', margin:'0'}}>
            <Grid.Col span={6}>
            <Button variant="outline" onClick={() => setSelectedView('contactStep1')} classNames={{ root: styles.buttonRootOutlined, label: styles.buttonLabel }} style={{ width: '100%' }} >{t('ui-general-yes') }</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button variant="outline" onClick={() => setSelectedView('email')} classNames={{ root: styles.buttonRootOutlined, label: styles.buttonLabel }} style={{ width: '100%' }} >{t('ui-general-no') }</Button>
            </Grid.Col>
          </Grid>
        </>

      }
      
      {(selectedView === 'email' || selectedView === 'contactStep1') &&
        <form onSubmit={form.onSubmit((values) => submit(values))}>
          <div className={styles.title}>{ t('ui-landing-welcome')}</div>
          <div className={styles.desc}>{t('ui-landing-please-select')}</div>
          <Group
            direction='column'
            spacing={8}
          >
            <Checkbox disabled checked={true} classNames={{ label: styles.label, input: styles.checkboxInput, icon: styles.checkboxIcon }} label={t('ui-landing-brochures')} />
            <Checkbox
              classNames={{ label: styles.label }}
              label={t('ui-landing-cad-drawings')}
              {...form.getInputProps('cad')}
            />
            {!indiaProduct &&
              <>
                <Checkbox
                  classNames={{ label: styles.label }}
                  label={t('ui-landing-bim-drawings')}
                  {...form.getInputProps('bim')}
                  disabled = {productCode === 'AMO' || productCode === 'HCM'}
                />
                <RadioGroup
                  ml={32}
                  spacing={8}
                  orientation='vertical'
                  description={<div className={styles.smallLabel}>
                    <div>{t('ui-landing-ifc')}</div>
                    <div>{t('ui-landing-rfa')}</div>
                  </div>}
                  {...form.getInputProps('lod')}
                >
                  {/* <Radio classNames={{ label: styles.label }} label={t('ui-landing-lod100')} value="100" disabled={!form.values.bim} /> */}
                  <Radio classNames={{ label: styles.label }} label={t('ui-landing-lod200')} value="200" disabled={!form.values.bim} />
                </RadioGroup>
              </>
            }
          </Group>
          {selectedView === 'email' &&
            <div className={styles.greyBox}>
              <div className={styles.info}>{t('ui-landing-notify-label')}</div>
              <TextInput
                label={t('ui-form-email')}
                required={true}
                classNames={{
                  label: styles.inputLabel,
                  input: styles.input
                }}
                // onChange={event=>handleFormOnChange(event, 'email')}
                // error={form.getInputProps('email').error}
                {...form.getInputProps('email')}
              />
              <Checkbox
                classNames={{ label: styles.label }}
                label={t('ui-landing-remember-me')}
                checked={form.values.remember}
                {...form.getInputProps('remember')}
              />
            </div>
          }
          <Space h="xs"/>
          <Text size="sm">
              {t('ui-contact-privacy-statement-1')}
                <a
                  tabIndex={-1}
                  className="readMore"
                  href={domainCountry?.privacyStatement}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  &nbsp;
                  {t('ui-contact-privacy-statement-2')}
                </a>
              {t('ui-contact-privacy-statement-3')}
          </Text>
          <Space h="xs"/>

          <div className={styles.alignRight}>
            <Button variant="outline" onClick={() => setSelectedView(null)} classNames={{ root: styles.buttonRootOutlined, label: styles.buttonLabel }} style={{ marginRight: '10px' }}>{t('ui-general-back')}</Button>
            {selectedView === 'email' && <Button type="submit" classNames={{ root: styles.buttonRoot, label: styles.buttonLabel }}>{t("ui-general-send")}</Button>}
            {selectedView === 'contactStep1' && <Button onClick={ () => submitOnlyOrder()} classNames={{ root: styles.buttonRoot, label: styles.buttonLabel }}>{t("ui-general-continue")}</Button>}
          </div>
        </form>
      }

      {selectedView === 'contactStep2' &&
        <ContactForm executeRecaptcha={executeRecaptcha} onCancel={ () => setSelectedView('contactStep1')} />
      }

    </Modal>
  );
}

export default LandingModal;